import { combineReducers } from 'redux';

import auth from "./auth";
import themeReducer from './themeReducers';
import alertMessages from "./alertMessages";
import userReducer from '../store/userSlice';
import videoReducer from '../store/videosSlice';
import routeReducer from '../store/routeSlice';
import reportsReducer from '../store/reportsSlice';
import i18nReducer from '../store/i18nSlice';


export default combineReducers({
  users: userReducer,
  videos: videoReducer,
  routes: routeReducer,
  reports: reportsReducer,
  i18n: i18nReducer,
  alertMessages,
  themeReducer,
  auth,
});